export const getDemoCards = () => import('./demoCards').then(({ demoCards }) => demoCards);
